import TAP from '../images/TAP.svg';
import AC3 from '../images/ac3.svg';
import SPORTS from '../images/sports.svg';
import WOK from '../images/weblok.svg';
import ICX from '../images/ICX.png';

export const renderIcon = (token: string) => {
  switch (token) {
    case 'AC3':
      return AC3;
    case 'SportsToken':
      return SPORTS;
    case 'weBloc':
      return WOK;
    case 'TapToken':
      return TAP;
    default:
      return ICX;
  }
};
